import AddButton from "components/Button/AddButton";
import React, { useEffect, useState } from "react";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DropdownStatusList, EmptyString, FormTypeAdd, PageSize, PaginationBack, PaginationFirst, PaginationLast, PaginationNext, StatusCodeActive, StatusCodeDelete } from "utils/Constant";
import { ApiDeleteEdc, ApiGetEdcBankList, ApiGetEdcList } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import EditIcon from "assets/icon/EditIcon";
import PaginationButton from "components/Input/PaginationButton";
import SearchButton from "components/Button/SearchButton";
import Dropdown from "components/Input/Dropdown";
import { addSpaceEvery4, GetStatus } from "utils/helpers";
import RevisionIcon from "assets/icon/RevisionIcon";
import { useModal } from "context/ModalContext";
import { useCallApi } from "api/apiHooks";
import Pagination from "components/Input/PaginationButton";
import { PagesTitle } from "components/Cards";

export default function EDC(){
    let navigate = useNavigate()
    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchEdcList, fetchEdcBankList, fetchDeleteEdc } = useCallApi()

    const [edcList, setEdcList] = useState([])
    const [bankId, setBankId] = useState(EmptyString)
    const [bankOptions, setBankOptions] = useState([])
    const [edcName, setEdcName] = useState(EmptyString)
    const [beneficiaryAccountNo, setBeneficiaryAccountNo] = useState(EmptyString)
    const [beneficiaryName, setBeneficiaryName] = useState(EmptyString)
    const [status, setStatus] = useState(DropdownStatusList[1].value)
    const [pageIndex, setPageIndex] = useState(0)
    const [totalPages, setTotalPages] = useState(0)

    const bankIdChange = (e) => {setBankId(e.value)}
    const edcNameChange = (e) => {setEdcName(e.target.value)}
    const beneficiaryNameChange = (e) => {setBeneficiaryName(e.target.value.toUpperCase())}
    const statusChange = (e) => {setStatus(e.value)}

    async function handlePageChange(newIndex) {
        try {
            showLoading()

            const res = await fetchEdcList(
                bankId,
                edcName, 
                beneficiaryAccountNo,
                beneficiaryName,
                status,
                PageSize,
                parseInt(newIndex)
            )

            if (!res) return

            const totalData = res?.data?.totalData ?? 0;
            const total = Math.max(1, Math.ceil(totalData / PageSize));

            setEdcList(res)
            setTotalPages(total);
            setPageIndex(newIndex);
        } finally {
            hideLoading();
        }
    }

    const filterEnterKeyPress = (e) => {
		if(e.key === 'Enter'){
			handlePageChange(0)
		}
	}
    const searchBtnClick = () => {
        handlePageChange(0)
    }
    const addBtnClick = () => {
        navigate("/setting/edc/form?edcId=&formType=" + FormTypeAdd)
    }
    const editBtnClick = (edcId) => {
        navigate("/setting/edc/form?edcId=" + edcId + "&formType=Edit")
    }
    const deleteBtnClick = async (edcId, status) => {
        const isConfirmed = await confirm()

        if (isConfirmed) {
            showLoading()

            const res = await fetchDeleteEdc(edcId, status)

            if (!res) return

            showSuccess()
            handlePageChange(pageIndex)
        }
    }

    useEffect(() => {
        showLoading()

        try {
            fetchEdcBankList().then((res) => {
                if (!res) return

                let data = res.data
                let tempArray = []

                tempArray.push({ label: "All", value: "" })

                for (let i = 0; i < data.length; i++){
                    tempArray.push({ label: data[i].bankCode + " - " + data[i].bankName, value: String(data[i].bankId) })
                }

                setBankOptions(tempArray)
                setBankId(tempArray[0].value)

                handlePageChange(0)
            })
        } finally {
            hideLoading()
        }
        
    },[])

    return(
        <div className="flex flex-col gap-2">
            <PagesTitle title='EDC' />

            <div className="flex flex-col sm:flex-row gap-5 justify-between mt-5">
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full">
                    <div className="flex flex-col gap-2 w-full">
                        <span>Bank</span>
                        <Dropdown value={bankId} options={bankOptions} onChange={bankIdChange} placeholder={"All"} />
                    </div>
                    <div className="flex flex-col gap-2 w-full">
                        <span>EDC Name</span>
                        <input className="input" value={edcName} onChange={edcNameChange} onKeyDown={filterEnterKeyPress} />
                    </div>
                    <div className="flex flex-col gap-2 w-full">
                        <span>Beneficiary Account</span>
                        <input className="input" value={beneficiaryName} onChange={beneficiaryNameChange} onKeyDown={filterEnterKeyPress} />
                    </div>
                    <div className="flex flex-col gap-2 w-full">
                        <span>Status</span>
                        <Dropdown value={status} options={DropdownStatusList} onChange={statusChange} placeholder={"All"} />
                    </div>
                </div>
                <div>
                    <div className="flex justify-end items-end h-full">
                        <SearchButton onClick={searchBtnClick} />                        
                    </div>
                </div>
            </div>

            <div className="flex w-full justify-end">
                <AddButton onClick={addBtnClick} />
            </div>
           
            <div className="mt-5">
                <table className="w-full border bg-white">
                    <thead>
                        <tr className="h-12">
                            <th className="font-semibold w-16">No</th>
                            <th className="font-semibold text-left px-2">EDC Name</th>
                            <th className="font-semibold text-left px-2">Type</th>
                            <th className="font-semibold text-left px-2">Beneficiary Account</th>
                            <th className="font-semibold text-left px-2">Account No</th>
                            <th className="font-semibold text-left px-2 w-20">On Us</th>
                            <th className="font-semibold text-left px-2 w-20">Off Us</th>
                            <th className="font-semibold text-left px-2 w-24">Qris On Us</th>
                            <th className="font-semibold text-left px-2 w-24">Qris Off Us</th>
                            <th className="font-semibold text-left px-2">Status</th>
                            <th className="font-semibold sm:w-24">Action</th>
                        </tr>
                    </thead>
                    <tbody className="border">
                        {edcList?.data?.listData?.map((data, i) => {
                            return(
                                <tr className="my-2 row h-10 border-y hover:bg-slate-100" key={ i }>
                                    <td className="text-center">{ data.rowNumber }</td>
                                    <td className="px-2">
                                        <span>{ data.bankCode + " - " + data.edcName }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.typeDesc }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.beneficiaryName }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ addSpaceEvery4(data.accountNo) }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.mdrOn }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.mdrOff }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.mdrQrisOn }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.mdrQrisOff }</span>
                                    </td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ GetStatus(data.status) }</span>
                                    </td>
                                    <td className="flex flex-col sm:flex-row justify-center py-2 gap-2 px-2">
                                        <button className="p-2 bg-black rounded-lg flex gap-2" onClick={() => editBtnClick(data.edcId)}>
                                            <EditIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`p-2 bg-black rounded-lg flex gap-2 ${ data.status === StatusCodeDelete ? "hidden" : "block" }`} onClick={() => deleteBtnClick(data.edcId, data.status)}>
                                            <TrashIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`p-2 bg-black rounded-lg flex gap-2 ${ data.status === StatusCodeActive ? 'hidden' : 'block' }`} onClick={() => deleteBtnClick(data.edcId, data.status)}>
                                            <RevisionIcon className="w-4 fill-white" />
                                        </button>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>

            <Pagination pageIndex={pageIndex} totalPages={totalPages} onPageChange={handlePageChange} />
        </div>
    )
}